import { useMemo } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import { formatPrice } from 'common/helpers'


const useReviewsData = (items) => {
  const { meta, subscriptionPrice } = useConnect({
    meta: 'view.seoPage.meta',
    subscriptionPrice: 'models.subscription.price',
  })

  const { ratingValue, ratingCount, reviewCount } = useMemo(() => {
    const hasRating     = items && items.length && items[0].rating !== null
    const hasReviews    = Boolean(items && items.length && items[0].reviewsCount)

    const ratedItems    = Boolean(items && items.length && hasRating) ? items.filter((item) => item.rating !== 0) : []
    const ratingSum     = ratedItems.reduce((result, { rating }) => result + parseInt(rating, 10), 0)
    const averageRating = ratedItems.length ? Math.round(ratingSum / ratedItems.length * 100) / 100 : undefined

    const totalReviews  = items.reduce((result, item) => result + item.reviewsCount, 0)

    const ratingValue   = hasRating ? String(averageRating) : 0
    const ratingCount   = String(ratedItems.length || 0)
    const reviewCount   = hasReviews ? String(totalReviews) : 0

    return {
      ratingValue,
      ratingCount,
      reviewCount,
    }
  }, [ items, subscriptionPrice ])


  const googleJsonData = useMemo(() => {
    const price = formatPrice(subscriptionPrice, true, false)

    return {
      '@context': 'http://schema.org',
      '@type': 'Product',

      url: meta.href,
      name: meta.name,
      category: meta.category,

      offers: {
        '@type': 'Offer',
        priceCurrency: 'USD',
        price,
        availability: 'http://schema.org/InStock',
      },

      aggregateRating: {
        '@type': 'AggregateRating',
        bestRating: '5',
        ratingValue,
        ratingCount,
        reviewCount,
      },
    }
  }, [ ratingValue, ratingCount, reviewCount, subscriptionPrice ])

  return {
    googleJsonData,
    ratingValue,
    ratingCount,
    reviewCount,
  }
}


export default useReviewsData
